export class TranslationView {
    en: string;
    fr: string;
    nl: string;

    constructor(data?: any) {
        this.en = data?.en ?? ""
        this.fr = data?.fr ?? ""
        this.nl = data?.nl ?? ""
    }
}

export class MessageBaseView extends TranslationView {
    id: number;
    name: string;
    de: string;
    sv: string;

    constructor(data?: any) {
        super(data)
        this.id = data?.id ?? 0
        this.name = data?.name ?? ""
        this.de = data?.de ?? ""
        this.sv = data?.sv ?? ""
    }
}
